import {
  DEFAULT_YAK_TRAILS_CONFIG,
  type PlayerSnapshot,
  type SessionKind,
  type TournamentRespawnPolicy,
} from "@games-monorepo/yak-trails-core";

export interface SpectatorActionState {
  canRespawn: boolean;
  buttonLabel: string;
  detail: string;
}

export function spectatorActionState(
  player: PlayerSnapshot,
  sessionKind: SessionKind,
  serverTimeMs: number,
  tournamentRespawnPolicy?: TournamentRespawnPolicy,
): SpectatorActionState {
  const maximumLives = DEFAULT_YAK_TRAILS_CONFIG.population.maximumLivesBySession[sessionKind];
  const livesStarted = player.livesStarted ?? 1;
  const hasTimedTournamentRespawns = sessionKind === "tournament"
    && tournamentRespawnPolicy !== undefined
    && tournamentRespawnPolicy !== "elimination";
  const livesExhausted = !hasTimedTournamentRespawns && (
    player.livesRemaining === 0
    || (player.livesRemaining === undefined && livesStarted >= maximumLives)
  );
  if (livesExhausted) {
    return {
      canRespawn: false,
      buttonLabel: sessionKind === "ranked_solo"
        ? "Run finished"
        : sessionKind === "tournament"
          ? "Heat finished"
          : "No lives left",
      detail: "You can keep watching or leave the arena.",
    };
  }

  const waitSeconds = Math.max(0, Math.ceil(((player.respawnAtMs ?? 0) - serverTimeMs) / 1_000));
  if (waitSeconds > 0) {
    return {
      canRespawn: false,
      buttonLabel: `Respawn in ${waitSeconds}s`,
      detail: "Your next safe territory is being prepared.",
    };
  }

  if (player.canRespawn === false) {
    return {
      canRespawn: false,
      buttonLabel: "Spawn unavailable",
      detail: "The claimed board cannot safely fit another player yet.",
    };
  }

  return {
    canRespawn: true,
    buttonLabel: sessionKind === "ranked_solo" ? "Rematch" : "Respawn",
    detail: "Jump back in whenever you are ready.",
  };
}
